module.exports = __webpack_public_path__ + "static/media/launch.7c232625.webp";